import { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, MailCheck } from "lucide-react";
import api, { formatApiError } from "@/lib/api";
import MetazikIcon from "@/components/MetazikIcon";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(null); // null | { email_enabled }
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setBusy(true);
    try {
      const { data } = await api.post("/auth/forgot-password", { email: email.trim() });
      setDone(data);
    } catch (e2) {
      setErr(!e2.response ? "Le serveur met du temps à répondre. Réessaie dans quelques secondes." : formatApiError(e2.response.data?.detail));
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen grid place-items-center p-4 bg-[#050505]" data-testid="forgot-page">
      <div className="w-full max-w-md bg-zinc-950/80 border border-white/10 rounded-3xl p-6 sm:p-8">
        <Link to="/auth" className="flex items-center gap-2 mb-6">
          <MetazikIcon className="w-9 h-9" />
          <span className="text-2xl font-black font-display text-white">Metazik</span>
        </Link>
        <h1 className="text-2xl font-black font-display text-white">Mot de passe oublié</h1>

        {done ? (
          <div className="mt-5 space-y-4" data-testid="forgot-done">
            {done.email_enabled ? (
              <p className="text-sm text-zinc-300 flex gap-3">
                <MailCheck className="w-5 h-5 text-emerald-400 shrink-0 mt-0.5" />
                Si un compte existe avec cette adresse, un e-mail vient de lui être envoyé avec un lien pour choisir un nouveau mot de passe. Il est valable 30 minutes. Pense à regarder tes courriers indésirables.
              </p>
            ) : (
              <p className="text-sm text-zinc-300">
                L'envoi automatique d'e-mails n'est pas encore actif. Écris à notre équipe : elle vérifiera ton identité et t'enverra un lien pour récupérer ton compte.
              </p>
            )}
            <Link to="/support" className="btn-primary w-full inline-flex justify-center" data-testid="forgot-to-support">Contacter le support</Link>
            <Link to="/auth" className="block text-center text-sm text-zinc-400 hover:text-white">Retour à la connexion</Link>
          </div>
        ) : (
          <form onSubmit={submit} className="mt-5 space-y-3">
            <p className="text-sm text-zinc-400">Entre l'adresse e-mail de ton compte. Nous t'enverrons un lien pour choisir un nouveau mot de passe.</p>
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Adresse e-mail" className="input-base" data-testid="forgot-email" />
            {err && <p className="text-sm text-red-400 bg-red-500/10 border border-red-500/20 rounded-xl px-3 py-2">{err}</p>}
            <button type="submit" disabled={busy} className="btn-primary w-full inline-flex items-center justify-center gap-2 disabled:opacity-60" data-testid="forgot-submit">
              {busy && <Loader2 className="w-4 h-4 animate-spin" />} Envoyer le lien
            </button>
            <Link to="/auth" className="block text-center text-sm text-zinc-400 hover:text-white">Retour à la connexion</Link>
            <p className="text-center text-xs text-zinc-500">Plus d'accès à ton e-mail ? <Link to="/support" className="underline">Contacte le support</Link>.</p>
          </form>
        )}
      </div>
    </div>
  );
}
